import api from "@/services/api";
import multiform from "@/services/multiform";

export default {
  get_user_data(payload) {
    return api
      .post("get_user_data/", payload)
      .then((response) => response.data);
  },
  save_cv(payload) {
    return multiform
      .post("save_cv/", payload)
      .then((response) => response.data);
  },
  // tooltip «Nuevo: modo reevaluación»: true cuando ya entró al modo
  getReevaluacionModeSeen() {
    return api.get("reevaluacion-mode-seen/").then((response) => response.data);
  },
  setReevaluacionModeSeen() {
    return api.post("reevaluacion-mode-seen/").then((response) => response.data);
  },
  alertMessageSeen() {
    return api.post("message_seen/").then((response) => response.data);
  },
  delete_cv(payload) {
    return api.post("delete_cv/", payload).then((response) => response.data);
  },
  send_feedback(payload) {
    return api
      .post("send_feedback/", payload)
      .then((response) => response.data);
  },
  checkUserCompleted(school) {
    return api
      .get(`users/check_info/?school=${school}`)
      .then((response) => response.data);
  },
  getBillData() {
    return api.get("users/get_bill_data/").then((response) => response.data);
  },
  saveBillData(payload) {
    return api
      .post("users/save_bill_data/", payload)
      .then((response) => response.data);
  },
  referUser(payload) {
    return api
      .post("users/refer_user/", payload)
      .then((response) => response.data);
  },
  // Public: who is behind an `?invita=` token (the visitor has no account yet).
  inviterInfo(token, service) {
    return api
      .get("users/inviter_info/", { params: { token, service } })
      .then((response) => response.data);
  },
  checkReferred(service) {
    return api
      .get("users/check_referred/", { params: { service } })
      .then((response) => response.data);
  },
  checkProfile() {
    return api.get("users/check_profile/").then((response) => response.data);
  },
  // Público: la tarjeta del enlace con QR (PromoCodeBanner) pregunta qué
  // regala el código antes de pedir sesión. Con sesión dice si ya se usó.
  promotionalCodeInfo(code) {
    return api
      .get("users/promotional_code_info/", { params: { code } })
      .then((response) => response.data);
  },
  redeemPromotionalCode(payload) {
    return api
      .post("users/redeem_promotional_code/", payload)
      .then((response) => response.data);
  },
  get_my_points(payload) {
    return api
      .post("get_my_points/", payload)
      .then((response) => response.data);
  },
  set_country(payload) {
    return api.post("set_country/", payload).then((response) => response.data);
  },
  updateUser(payload, userID) {
    return api
      .patch(`users/${userID}/`, payload)
      .then((response) => response.data);
  },
  getUserDataByID(payload) {
    return api
      .post("get_user_data_by_id/", payload)
      .then((response) => response.data);
  },
  deleteAccount() {
    return api.post("delete_account/").then((response) => response.data);
  },
  addTransactionPoints(payload) {
    return api
      .post("add_transaction_points/", payload)
      .then((response) => response.data);
  },
  dontShowAgain() {
    return api.get("dont_show_again/").then((response) => response.data);
  },
  checkDontShow() {
    return api
      .get("check-show-professional-warning/")
      .then((response) => response.data);
  },
  updateDontShow() {
    return api
      .post("update-show-professional-warning/")
      .then((response) => response.data);
  },
  getModals() {
    return api.get(`get-modals/`).then((response) => {
      return response.data;
    });
  },
  updateShowModal(payload) {
    return api.post(`update-modal/`, payload).then((response) => {
      return response.data;
    });
  },
  validateUser(payload) {
    return api
      .post("users/validate_user/", payload)
      .then((response) => response.data);
  },
  createShortUser(payload) {
    return api
      .post("users/create_short_user/", payload)
      .then((response) => response.data);
  },
};
